export default __webpack_public_path__ + "static/media/phoneFrame.c7627fe0.svg";